import React from 'react';
import SpaceUsageItemsList from "../SpaceUsageItemsList";
import Pagination from "../deprecatedUikit/Pagination/Pagination";
import { Grid } from "@mui/material";

/**
 * Paginated list of space usage items
 *
 * @param {Object} props
 * @param {Array} props.spaceUsageItems - List of booked space calendar views
 * @param {number} props.count - Total count of items
 * @param {number} props.rowsPerPage - Number of rows per page
 * @param {Function} props.onRowsPerPageChange - Handler for rows per page change
 * @param {number} props.page - Current page number
 * @param {Function} props.onPageChange - Handler for page change
 * @param {Function} props.onViewOverageInvoices - Handler for viewing overage invoices
 * @returns {JSX.Element}
 */
const SpaceUsageItemsPaginated = (props) => {
  const { spaceUsageItems, count, page, rowsPerPage, onRowsPerPageChange, onPageChange, onViewOverageInvoices } = props;

  return (
    <Grid item container rowGap={'2rem'} component={'section'}>
      <SpaceUsageItemsList spaceUsageItems={spaceUsageItems} onViewOverageInvoices={onViewOverageInvoices} />
      <Grid sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'flex-end',
      }}>
        <Pagination
          onPageChange={onPageChange}
          count={count}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={onRowsPerPageChange}
          page={page}
          variant={'tablePagination'}
          scrollToBottomOnPageChange={true}
        />
      </Grid>
    </Grid>
  );
};

export default SpaceUsageItemsPaginated;
